import { Box, Link, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import appConfig from '../config/appConfig';

const HELP_AND_SUPPORT_URL = appConfig.helpAndSupportUrl;
export default function SideBottomBar({ mini }) {
  return (
    <>
      {mini ? (
        <></>
      ) : (
        <Box
          sx={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1100,
            backgroundColor: 'background.paper',
            borderTop: 1,
            borderColor: 'divider',
            p: 1,
          }}
        >
          <List disablePadding>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                href={HELP_AND_SUPPORT_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'text.primary',
                  flexDirection: mini ? 'column' : 'row',
                  alignItems: 'center',
                  textAlign: mini ? 'center' : 'left',
                  py: mini ? 1.5 : 1,
                  '&:hover': { backgroundColor: 'action.hover' },
                  borderRadius: 2,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: mini ? 'auto' : 36,
                    justifyContent: 'center',
                    mb: mini ? 0.5 : 0,
                    color: 'text.secondary',
                    paddingLeft: mini ? 2 : 0,
                    paddingRight: mini ? 0 : 2,
                  }}
                >
                  <HelpOutlineIcon fontSize="medium" />
                </ListItemIcon>
                <ListItemText
                  primary={'Help & Support'}
                  slotProps={{
                    primary: {
                      fontSize: mini ? 10 : 17,
                      fontWeight: mini ? 500 : 400,
                      textAlign: mini ? 'center' : 'left',
                      paddingLeft: mini ? 1 : 0,
                    },
                  }}
                  sx={{ m: 0 }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      )}
    </>
  );
}
